import { SharedErrors } from 'web_core_library';

export enum EAssessmentSubpage {
  None = 'none',
  Session = 'session',
  CFQ = 'cfq',
  CFQEvaluation = 'cfqEvaluation',
  Evaluation = 'evaluation',
  TrainingSchedule = 'trainingSchedule',
  PeerGroup = 'peerGroup',
  SpecialNeeds = 'specialNeeds',
  LED = 'led',
  Intensity = 'intensity',
}

export class AssessmentError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, AssessmentError.prototype);
    this.feature = 'Assessment';
  }
}

export type TAssessmentWorkoutResult = {
  workoutId: number;
  result: number;
};

export interface IOpenWorkoutPayload {
  workoutId: number;
  index: number;
  exerciseId: string;
}

export interface IOpenCFQQuestionPayload {
  workoutId: number;
  index: number;
}
